// src/features/orders/staffSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Staff type
export interface Staff {
  id: string;
  [key: string]: any; // flexible, allow extra fields from API
}

// API response shape for data
interface StaffListResponse {
  staffs: Staff[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface StaffState {
  data: StaffListResponse | null;
  loading: boolean;
  error: string | null;
}

// Payload for updating a staff
export interface StaffUpdatePayload {
  id: string;
  [key: string]: any;
}

// ✅ Initial state
const initialState: StaffState = {
  data: null,
  loading: false,
  error: null,
};

// ✅ Slice
const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    // Set full staff data response
    setStaffList(state, action: PayloadAction<StaffListResponse>) {
      state.data = action.payload;
      state.loading = false;
    },

    // Add a new staff
    addStaff(state, action: PayloadAction<Staff>) {
      // 1. The payload **is** the staff object
      const newStaffRaw = action.payload;

      // 2. Normalise it (same as before, but use the raw payload)
      const newStaff: Staff = {
        id: newStaffRaw.id ?? crypto.randomUUID(),
        status: newStaffRaw.status ?? "ACTIVE",
        email: newStaffRaw.email ?? "",
        name: newStaffRaw.name ?? "",
        phone: newStaffRaw.phone ?? "",
        city: newStaffRaw.city ?? "",
        country: newStaffRaw.country ?? "",
        address: newStaffRaw.address ?? "",
        iqamaNo: newStaffRaw.iqamaNo ?? "",
        roleName: newStaffRaw.roleName ?? "",
        roles: newStaffRaw.roles ?? "",
        startDate: newStaffRaw.startDate ?? new Date().toISOString(),
        created_at: newStaffRaw?.createdAt ?? new Date().toISOString(),
        photo: newStaffRaw?.photo ?? ""
        // add any other fields you need
      };

      // 3. Insert into the list (unchanged)
      if (state.data?.staffs) {
        state?.data?.staffs?.unshift(newStaff);
        state.data.total += 1;
        if (state?.data?.staffs?.length > 10) state?.data?.staffs?.pop();
      } else {
        state.data = {
          staffs: [newStaff],
          total: 1,
          page: 1,
          totalPages: 1,
        };
      }
    },
    // Update staff by id
    staffUpdate(state, action: PayloadAction<StaffUpdatePayload>) {
      console.log(action,'acitons')
      const { id, ...updates } = action.payload;
      console.log(id,'id')
      if (!id || !state.data) return;

      console.log(state.data,'data')
      const staff = state.data.staffs.find((p) => p.id === id);
      if (staff) {
        Object.assign(staff, updates);
      }
    },

    // Set loading state
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    // Set error state
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

// ✅ Export actions
export const {
  setStaffList,
  addStaff,
  staffUpdate,
  setLoading,
  setError,
} = staffSlice.actions;

// ✅ Export reducer
export default staffSlice.reducer;
